import React from 'react';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import TranscriptBlockContainer from '@layout/TranscriptBlockContainer';
import messages from './messages';

export const TranscriptContents = () => (
  <TranscriptBlockContainer.MainContainer
    className="page-break-avoid"
    id="transcript-contents"
  >
    <TranscriptBlockContainer.H2>
      <FormattedMessage {...messages.title} />
    </TranscriptBlockContainer.H2>
  </TranscriptBlockContainer.MainContainer>
);

TranscriptContents.propTypes = {
  intl: intlShape.isRequired,
};

export default injectIntl(TranscriptContents);



// WEBPACK FOOTER //
// ./components/molecules/TranscriptContents/TranscriptContents.js